<script setup lang="ts">
defineProps<{
  label?: string;
}>();
</script>

<template>
  <button
    class="btn btn-sm btn-outline-secondary w-100 d-flex gap-2 align-items-center justify-content-center"
    type="button"
    aria-label="Vis information"
  >
    <i class="bi bi-info-circle"></i>
    <span>{{ label || "Information" }}</span>
  </button>
</template>
